export default function Tarifs() {
  return (
    <section id="tarifs" className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-3">
          Des tarifs clairs, sans surprise.
        </h2>
        <p className="text-brand-text text-base md:text-lg mb-8">
          Diagnostic et devis gratuits.
        </p>
        <a
          href="/tarifs"
          className="flex items-center gap-2 bg-brand-cyan text-white px-7 py-3.5 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect w-full sm:w-auto text-center overflow-hidden justify-center"
        >
          Voir nos tarifs
          <span className="btn-icon-wrap"><i className="ri-arrow-right-line text-lg"></i></span>
        </a>
      </div>
    </section>
  );
}